import { Stack } from '@chakra-ui/react'
import { InputFormControl, TextareaFormControl } from 'BrokerTsLib/src/components'
import type { EditOrganizationUnit } from 'BrokerTsLib/src/dtos'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import type { Ref } from 'react'
import { forwardRef } from 'react'

import type { FormSectionProps } from '@/containers/forms/FormSection'
import { FormSection } from '@/containers/forms/FormSection'

export const OrganizationTravelInsuranceFormSection = forwardRef(
  function OrganizationTravelInsuranceFormSection(props: FormSectionProps, ref: Ref<HTMLDivElement>) {
    const { control } = useFormContext<EditOrganizationUnit>()

    return <FormSection ref={ref} sectionTitle='Nastavení cestovního pojištění' {...props}>
      <Stack gap={6}>
        <TextareaFormControl label="Odkazy na dokumenty"
          placeholder="Odkazy na dokumenty ke stažení"
          control={control} name="properties.preContractDocumentLinks3" />
        <InputFormControl label="Odkaz na IPID"
          placeholder="Odkaz na IPIDy"
          control={control} name="properties.ipidLink3" />
      </Stack>
    </FormSection>
  }
)